import { render, staticRenderFns } from "./ComprobanteRow2.vue?vue&type=template&id=30c60989"
import script from "./ComprobanteRow2.vue?vue&type=script&lang=js"
export * from "./ComprobanteRow2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports